import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { APGenericSlot, CourseGroupSlot, WildcardSlot } from '../../../../global/builders/ap_generic_slot_builder';
import { INVALID_ID } from '../../../../global/constants/ap_id_constants';

export interface ILargeCourseGroupModel {
  selectedTerm: number;
  selectedSlot: CourseGroupSlot | WildcardSlot;
}

export type LargeCourseGroupModel = ITypedModel<ILargeCourseGroupModel>;
angular.module('capability-ng-academic-planner').factory(
  'ngLargeCourseGroupModel',
  () =>
    new Model<ILargeCourseGroupModel>({
      selectedTerm: INVALID_ID,
      selectedSlot: {} as CourseGroupSlot | WildcardSlot
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/large_course_group/models/large_course_group_model.ts